module.exports = __webpack_public_path__ + "img/portfolio1-m@2.7a49e49d.webp";